<script>
  import Page from '@components/page'
  import Button from '@components/buttons/button.svelte'
  import Block from '@components/general/block'
  import Message from '@components/general/message.svelte'
  import { IconMessage } from '@tabler/icons-svelte'
  import { ExternalLink, Users, MessageCircle, Handshake } from 'lucide-svelte'

  let title = "Community"
  let linkedinUrl = "https://www.linkedin.com/groups/17844051"
</script>

<Page.Layout title={title}>
  
  <Page.Navigation title={title} Icon={IconMessage} />
  
  <Page.Titles title={title} subtitle="Connect with fellow members between sessions" />
  
  <Page.Content>

    {#snippet main()}
      <Block.Element label="LinkedIn Group" title="Our Private Community">
        <div class="flex flex-col gap-6 my-3">
          <p class="text-sm text-gray-500 leading-relaxed">Our private LinkedIn group is where Altruist members come together to share insights, ask questions, and support one another between sessions.</p>

          <div class="flex flex-col gap-4">
            <div class="flex items-start gap-3">
              <MessageCircle size={18} class="text-gray-400 mt-0.5 shrink-0" />
              <div>
                <p class="text-sm font-medium text-gray-700">Continue the conversation</p>
                <p class="text-smaller text-gray-500">Discuss topics from sessions and share your experiences</p>
              </div>
            </div>
            <div class="flex items-start gap-3">
              <Users size={18} class="text-gray-400 mt-0.5 shrink-0" />
              <div>
                <p class="text-sm font-medium text-gray-700">Connect with members</p>
                <p class="text-smaller text-gray-500">Build relationships with like-minded professionals</p>
              </div>
            </div>
            <div class="flex items-start gap-3">
              <Handshake size={18} class="text-gray-400 mt-0.5 shrink-0" />
              <div>
                <p class="text-sm font-medium text-gray-700">Peer support</p>
                <p class="text-smaller text-gray-500">Give and receive support in a safe, private space</p>
              </div>
            </div>
          </div>

          <Button variant="bold" externalPath={linkedinUrl} text="Join the LinkedIn Group" Icon={ExternalLink} class="w-full justify-center mt-2" />
        </div>
      </Block.Element>
    {/snippet}

    {#snippet aside()}
      <Message type="info" title="Private group">
        <p class="text-smaller">This is a private LinkedIn group exclusively for Altruist members. Your request to join will be reviewed by the team.</p>
      </Message>
    {/snippet}

  </Page.Content>
</Page.Layout>
